const BASE_OPTIONS = {
    showHideTransition: 'fade',
    allowToastClose: true,
    stack: false,
    position: 'top-center',
    textAlign: 'center',
    loader: false,
    hideAfter: false
};

export function Error(text, hideAfter = false) {
    $.toast({
        ...BASE_OPTIONS,
        text: `
          <div role="alert" aria-live="assertive" aria-atomic="true">
            <i class="fal fa-circle-exclamation custom-font-size" aria-hidden="true"></i>
            <span>${text}</span>
          </div>
        `,
        bgColor: '#e74c3c',
        textColor: '#ffffff',
        hideAfter: hideAfter
    });
}

export function Info(text) {
    $.toast({
        ...BASE_OPTIONS,
        text: `
          <div role="status" aria-live="polite" aria-atomic="true">
            <i class="fal fa-circle-check custom-font-size" aria-hidden="true"></i>
            <span>${text}</span>
          </div>
        `,
        bgColor: '#00778B',
        textColor: '#ffffff',
        hideAfter: 5000
    });
}

export function Success(text) {
    $.toast({
        ...BASE_OPTIONS,
        text: `
          <div role="status" aria-live="polite" aria-atomic="true">
            <i class="fal fa-circle-check custom-font-size" aria-hidden="true"></i>
            <span>${text}</span>
          </div>
        `,
        bgColor: '#48B159',
        textColor: '#ffffff',
        hideAfter: 5000
    });
}
